import { Typography, Paper, Box } from "@mui/material";
import baseTheme from "../themes/baseTheme";
import { createTheme, ThemeProvider } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import IconButton from "@mui/material/IconButton";
import { CompaniesContext } from "../store/companies-context";
import { useState, useContext } from "react";
//Create an empty theme and use ThemeProvider to make Box "sx" work!!
const theme = createTheme({});

export default function ({ headers, padding,  }) {
  const companiesContext = useContext(CompaniesContext);
  const [sortOrderAsc, setSortOrderAsc] = useState(companiesContext?.sortOrder == "asc");
  
  const handleToggle = () => {
    companiesContext?.setSortOrder(!sortOrderAsc ? "asc" : "dsc");
    setSortOrderAsc(prevSortOrderAsc => !prevSortOrderAsc);
  };
  
  return (
    <ThemeProvider theme={theme}>
      <Box
        display="flex"
        padding={padding}
        borderBottom="solid 1px"
        borderColor={baseTheme.palette.grey[30]}
        backgroundColor="transparent"
      >
        {headers.map((hdr) => (
          <Box
            key={hdr.id}
            width={hdr.width}
            sx={{ color: baseTheme.palette.grey[80] }}
          >
            <Typography variant="subtitle2">
              {hdr.text}
              {hdr.id == "CompanyName" && (
                <IconButton onClick={handleToggle}>
                  {sortOrderAsc ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>
              )}
            </Typography>
          </Box>
        ))}
      </Box>
    </ThemeProvider>
  );
}
